import { Box, Grid, Paper, Typography } from "@material-ui/core";
import Controls from "../../../../components/controls/Controls";
import FormBase from "../../../../forms/FormBase";
import AttachmentForm from "../../../../forms/corpoClinico/AttachmentForm";
import FormFieldAttachmentBase, {
  FieldAttachment,
} from "../../../../forms/FormFieldAttachmentBase";

interface ICorpoClinicoAttachmentDataComponentProps {
  CorpoClinicoAttachmentForm: AttachmentForm;
  onInputChange: (
    name: string,
    form: FormBase,
    fieldAttachment: FieldAttachment,
    formField: FormFieldAttachmentBase
  ) => void;
  onDeleteFile: (
    name: string,
    form: FormBase,
    fieldAttachment: FieldAttachment,
    formField: FormFieldAttachmentBase
  ) => void;
}

export default function CorpoClinicoAttachmentDataComponent(
  props: ICorpoClinicoAttachmentDataComponentProps
) {
  return (
    <div>
      <Grid container spacing={10}>
        <Grid item xs={6}>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Controls.Attachment
                label="Atestado de Capacidade Física e Cognitiva *"
                name="AtestadoCapacidadeFisicaCognitiva"
                limitedFiles={
                  props.CorpoClinicoAttachmentForm
                    .AtestadoCapacidadeFisicaCognitiva.LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.CorpoClinicoAttachmentForm
                    .AtestadoCapacidadeFisicaCognitiva.Values
                }
                error={
                  props.CorpoClinicoAttachmentForm
                    .AtestadoCapacidadeFisicaCognitiva.Error
                }
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "AtestadoCapacidadeFisicaCognitiva",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm
                      .AtestadoCapacidadeFisicaCognitiva
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "AtestadoCapacidadeFisicaCognitiva",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm
                      .AtestadoCapacidadeFisicaCognitiva
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Carteira de Vacinação atualizada"
                infoMessage="Em caso de recusa, favor preencher o Termo disponível na última página da solicitação"
                name="CarteiraVacinacaoOuTermo"
                limitedFiles={
                  props.CorpoClinicoAttachmentForm.CarteiraVacinacaoOuTermo
                    .LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.CorpoClinicoAttachmentForm.CarteiraVacinacaoOuTermo
                    .Values
                }
                error={
                  props.CorpoClinicoAttachmentForm.CarteiraVacinacaoOuTermo
                    .Error
                }
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CarteiraVacinacaoOuTermo",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm.CarteiraVacinacaoOuTermo
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CarteiraVacinacaoOuTermo",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm.CarteiraVacinacaoOuTermo
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Certidão de Ética Profissional (emitida pelo site do CREMESP)*"
                name="CertidaoEticaProfissional"
                limitedFiles={
                  props.CorpoClinicoAttachmentForm.CertidaoEticaProfissional
                    .LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.CorpoClinicoAttachmentForm.CertidaoEticaProfissional
                    .Values
                }
                error={
                  props.CorpoClinicoAttachmentForm.CertidaoEticaProfissional
                    .Error
                }
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CertidaoEticaProfissional",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm.CertidaoEticaProfissional
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CertidaoEticaProfissional",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm.CertidaoEticaProfissional
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Certidão de Quitação *"
                name="CertidaoQuitacao"
                limitedFiles={
                  props.CorpoClinicoAttachmentForm.CertidaoQuitacao.LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.CorpoClinicoAttachmentForm.CertidaoQuitacao.Values
                }
                error={props.CorpoClinicoAttachmentForm.CertidaoQuitacao.Error}
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CertidaoQuitacao",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm.CertidaoQuitacao
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CertidaoQuitacao",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm.CertidaoQuitacao
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Cópia da Carteira do Conselho *"
                name="CopiaCRM"
                limitedFiles={
                  props.CorpoClinicoAttachmentForm.CopiaCRM.LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={props.CorpoClinicoAttachmentForm.CopiaCRM.Values}
                error={props.CorpoClinicoAttachmentForm.CopiaCRM.Error}
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CopiaCRM",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm.CopiaCRM
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CopiaCRM",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm.CopiaCRM
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Comprovante de Vacinação COVID19"
                name="ComprovanteVacinaCovid"
                limitedFiles={props.CorpoClinicoAttachmentForm.ComprovanteVacinaCovid.LimitedFiles}
                typeFiles={"image/*, .pdf"}
                values={props.CorpoClinicoAttachmentForm.ComprovanteVacinaCovid.Values}
                error={props.CorpoClinicoAttachmentForm.ComprovanteVacinaCovid.Error}
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "ComprovanteVacinaCovid",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm.ComprovanteVacinaCovid
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "ComprovanteVacinaCovid",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm.ComprovanteVacinaCovid
                  );
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Controls.Attachment
                label="Cópia do RG *"
                name="CopiaRG"
                limitedFiles={
                  props.CorpoClinicoAttachmentForm.CopiaRG.LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={props.CorpoClinicoAttachmentForm.CopiaRG.Values}
                error={props.CorpoClinicoAttachmentForm.CopiaRG.Error}
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CopiaRG",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm.CopiaRG
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CopiaRG",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm.CopiaRG
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Currículo resumido atualizado *"
                name="CurriculoResumidoAtualizado"
                limitedFiles={
                  props.CorpoClinicoAttachmentForm.CurriculoResumidoAtualizado
                    .LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.CorpoClinicoAttachmentForm.CurriculoResumidoAtualizado
                    .Values
                }
                error={
                  props.CorpoClinicoAttachmentForm.CurriculoResumidoAtualizado
                    .Error
                }
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CurriculoResumidoAtualizado",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm.CurriculoResumidoAtualizado
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CurriculoResumidoAtualizado",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm.CurriculoResumidoAtualizado
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Uma foto 3x4 fundo branco *"
                name="Foto"
                limitedFiles={
                  props.CorpoClinicoAttachmentForm.Foto.LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={props.CorpoClinicoAttachmentForm.Foto.Values}
                error={props.CorpoClinicoAttachmentForm.Foto.Error}
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "Foto",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm.Foto
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "Foto",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm.Foto
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Declaração de Conflitos - Anexo *"
                name="DeclaracaoConflitos"
                limitedFiles={
                  props.CorpoClinicoAttachmentForm.DeclaracaoConflitos
                    .LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.CorpoClinicoAttachmentForm.DeclaracaoConflitos.Values
                }
                error={
                  props.CorpoClinicoAttachmentForm.DeclaracaoConflitos.Error
                }
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "DeclaracaoConflitos",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm.DeclaracaoConflitos
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "DeclaracaoConflitos",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm.DeclaracaoConflitos
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Cópia do Diploma de Graduação em Medicina *"
                name="CopiaDiplomaGraduacaoMedicina"
                limitedFiles={
                  props.CorpoClinicoAttachmentForm.CopiaDiplomaGraduacaoMedicina
                    .LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.CorpoClinicoAttachmentForm.CopiaDiplomaGraduacaoMedicina
                    .Values
                }
                error={
                  props.CorpoClinicoAttachmentForm.CopiaDiplomaGraduacaoMedicina
                    .Error
                }
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CopiaDiplomaGraduacaoMedicina",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm
                      .CopiaDiplomaGraduacaoMedicina
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CopiaDiplomaGraduacaoMedicina",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm
                      .CopiaDiplomaGraduacaoMedicina
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Registro de Qualificação de Especialista (RQE) *"
                name="RegistroQualificacaoEspecialistaRQE"
                limitedFiles={
                  props.CorpoClinicoAttachmentForm.RegistroQualificacaoEspecialistaRQE
                    .LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.CorpoClinicoAttachmentForm.RegistroQualificacaoEspecialistaRQE
                    .Values
                }
                error={
                  props.CorpoClinicoAttachmentForm.RegistroQualificacaoEspecialistaRQE
                    .Error
                }
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "RegistroQualificacaoEspecialistaRQE",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm
                      .RegistroQualificacaoEspecialistaRQE
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "RegistroQualificacaoEspecialistaRQE",
                    props.CorpoClinicoAttachmentForm,
                    fieldAttachment,
                    props.CorpoClinicoAttachmentForm
                      .RegistroQualificacaoEspecialistaRQE
                  );
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <br />
      <br />

      <Paper variant="outlined">
        <Box p={1}>
          <Typography variant="subtitle1" gutterBottom component="div">
            Cópia do Título de Especialista ou Residência Médica *
          </Typography>

          <Grid container spacing={10}>
            <Grid item xs={6}>
              <Grid container spacing={5}>
                <Grid item xs={12}>
                  <Controls.Attachment
                    label="Título de Especialista"
                    name="CopiaTituloEspecialista"
                    infoMessage="Título de Especialista (Frente e Verso) - (Mínimo 2 anos da data de conclusão)"
                    limitedFiles={
                      props.CorpoClinicoAttachmentForm.CopiaTituloEspecialista
                        .LimitedFiles
                    }
                    typeFiles={"image/*, .pdf"}
                    values={
                      props.CorpoClinicoAttachmentForm.CopiaTituloEspecialista
                        .Values
                    }
                    error={
                      props.CorpoClinicoAttachmentForm.CopiaTituloEspecialista
                        .Error
                    }
                    onDeleteFile={(fieldAttachment: FieldAttachment) => {
                      props.onDeleteFile(
                        "CopiaTituloEspecialista",
                        props.CorpoClinicoAttachmentForm,
                        fieldAttachment,
                        props.CorpoClinicoAttachmentForm.CopiaTituloEspecialista
                      );
                    }}
                    onChange={(fieldAttachment: FieldAttachment) => {
                      props.onInputChange(
                        "CopiaTituloEspecialista",
                        props.CorpoClinicoAttachmentForm,
                        fieldAttachment,
                        props.CorpoClinicoAttachmentForm.CopiaTituloEspecialista
                      );
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid container spacing={5}>
                <Grid item xs={12}>
                  <Controls.Attachment
                    label="Residência Médica"
                    name="CopiaResidenciaMedica"
                    infoMessage="Residência Médica (Frente e Verso) - (Mínimo 2 anos da data de conclusão)"
                    limitedFiles={
                      props.CorpoClinicoAttachmentForm.CopiaResidenciaMedica
                        .LimitedFiles
                    }
                    typeFiles={"image/*, .pdf"}
                    values={
                      props.CorpoClinicoAttachmentForm.CopiaResidenciaMedica
                        .Values
                    }
                    error={
                      props.CorpoClinicoAttachmentForm.CopiaResidenciaMedica
                        .Error
                    }
                    onDeleteFile={(fieldAttachment: FieldAttachment) => {
                      props.onDeleteFile(
                        "CopiaResidenciaMedica",
                        props.CorpoClinicoAttachmentForm,
                        fieldAttachment,
                        props.CorpoClinicoAttachmentForm.CopiaResidenciaMedica
                      );
                    }}
                    onChange={(fieldAttachment: FieldAttachment) => {
                      props.onInputChange(
                        "CopiaResidenciaMedica",
                        props.CorpoClinicoAttachmentForm,
                        fieldAttachment,
                        props.CorpoClinicoAttachmentForm.CopiaResidenciaMedica
                      );
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <br />
          <Typography variant="caption" display="block" gutterBottom>
            Obs.: Pode ser anexado um arquivo.
          </Typography>
        </Box>
      </Paper>

      <br />
      <br />

      <Paper variant="outlined">
        <Box p={1}>
          <Typography variant="subtitle1" gutterBottom component="div">
            Cópia dos certificados do curso de reanimação
          </Typography>

          <Grid container spacing={10}>
            <Grid item xs={6}>
              <Grid container spacing={5}>
                <Grid item xs={12}>
                  <Controls.Attachment
                    label="Treinamento ACLS"
                    name="CopiaCertificadosCursoReanimacaoTreinamentoACLS"
                    limitedFiles={
                      props.CorpoClinicoAttachmentForm
                        .CopiaCertificadosCursoReanimacaoTreinamentoACLS
                        .LimitedFiles
                    }
                    typeFiles={"image/*, .pdf"}
                    values={
                      props.CorpoClinicoAttachmentForm
                        .CopiaCertificadosCursoReanimacaoTreinamentoACLS.Values
                    }
                    error={
                      props.CorpoClinicoAttachmentForm
                        .CopiaCertificadosCursoReanimacaoTreinamentoACLS.Error
                    }
                    onDeleteFile={(fieldAttachment: FieldAttachment) => {
                      props.onDeleteFile(
                        "CopiaCertificadosCursoReanimacaoTreinamentoACLS",
                        props.CorpoClinicoAttachmentForm,
                        fieldAttachment,
                        props.CorpoClinicoAttachmentForm
                          .CopiaCertificadosCursoReanimacaoTreinamentoACLS
                      );
                    }}
                    onChange={(fieldAttachment: FieldAttachment) => {
                      props.onInputChange(
                        "CopiaCertificadosCursoReanimacaoTreinamentoACLS",
                        props.CorpoClinicoAttachmentForm,
                        fieldAttachment,
                        props.CorpoClinicoAttachmentForm
                          .CopiaCertificadosCursoReanimacaoTreinamentoACLS
                      );
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid container spacing={5}>
                <Grid item xs={12}>
                  <Controls.Attachment
                    label="Treinamento PALS"
                    name="CopiaCertificadosCursoReanimacaoTreinamentoPALS"
                    limitedFiles={
                      props.CorpoClinicoAttachmentForm
                        .CopiaCertificadosCursoReanimacaoTreinamentoPALS
                        .LimitedFiles
                    }
                    typeFiles={"image/*, .pdf"}
                    values={
                      props.CorpoClinicoAttachmentForm
                        .CopiaCertificadosCursoReanimacaoTreinamentoPALS.Values
                    }
                    error={
                      props.CorpoClinicoAttachmentForm
                        .CopiaCertificadosCursoReanimacaoTreinamentoPALS.Error
                    }
                    onDeleteFile={(fieldAttachment: FieldAttachment) => {
                      props.onDeleteFile(
                        "CopiaCertificadosCursoReanimacaoTreinamentoPALS",
                        props.CorpoClinicoAttachmentForm,
                        fieldAttachment,
                        props.CorpoClinicoAttachmentForm
                          .CopiaCertificadosCursoReanimacaoTreinamentoPALS
                      );
                    }}
                    onChange={(fieldAttachment: FieldAttachment) => {
                      props.onInputChange(
                        "CopiaCertificadosCursoReanimacaoTreinamentoPALS",
                        props.CorpoClinicoAttachmentForm,
                        fieldAttachment,
                        props.CorpoClinicoAttachmentForm
                          .CopiaCertificadosCursoReanimacaoTreinamentoPALS
                      );
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <br />
          <Typography variant="caption" display="block" gutterBottom>
            Obs.: Pode ser anexado um arquivo.
          </Typography>
        </Box>
      </Paper>
    </div>
  );
}
